import React,{Suspense,lazy} from "react";
import {Routes,Route} from "react-router-dom";

const Authlayout = lazy(() => import('./layout/authlayout'));
const Login = lazy(() => import('./pages/login'));
const Signup = lazy(() => import('./pages/signup'));
const Forgetpassword = lazy(() => import('./pages/forgetpassword'));
const Forgetpassverify = lazy(() => import('./pages/forgetpassverify'));
const Passwordreset = lazy(() => import('./pages/passwordreset'));
const Subverification = lazy(() => import('./pages/subverification'));
const Nopage = lazy(() => import('./pages/nopage'));

function App() {
  return (
    <>
      <Suspense fallback={<p>Loading...</p>}>
        <Routes>
          <Route path="/" element={<Authlayout><Login /></Authlayout>} />
          <Route path="/signup" element={<Authlayout><Signup /></Authlayout>} />
          <Route path="/subverification/:token" element={<Authlayout><Subverification /></Authlayout>} />
          <Route path="/forgetpassword" element={<Authlayout><Forgetpassword /></Authlayout>} />
          <Route path="/forgetpassverify/:token" element={<Authlayout><Forgetpassverify /></Authlayout>} />
          <Route path="/passwordreset/:token" element={<Authlayout><Passwordreset /></Authlayout>} />
          <Route path="*" element={<Authlayout><Nopage /></Authlayout>} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
